import { Tag } from "ui-kit/icon";
import { IIngestionSourceData } from './types';

const winsale: IIngestionSourceData = {
  isEcom: false,
  isAutomated: false,
  displayName: "WinSale",
  listInventory: {
    linkHref: "/listInventory/winsale",
    icon: Tag
  }
};

export default winsale;
